import {
    userFavoritesLoading,
    getFavoritesSuccess,
    getFavoritesFailure,
    addingFavorite,
    postFavoriteDashboardSuccess,
    postFavoriteDashboardFailure,
    removingFavorite,
    removeFavoriteDashboardSuccess,
    removeFavoriteDashboardFailure,
} from 'redux/actions/user';
import * as requests from 'api/requests';
import { displayErrorSwal } from 'utilities/Validations';

export function getUserFavorites() {
    return (dispatch) => {
        dispatch(userFavoritesLoading());

        return requests
            .getUserFavoriteDashboards()
            .then((data) => {
                dispatch(getFavoritesSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal(`An error occurred getting user's favorite dashboards, please try again later.`);
                dispatch(getFavoritesFailure(error));
            });
    };
}

export function getUserFavoritesBySiteId(siteId) {
    return (dispatch) => {
        dispatch(userFavoritesLoading());

        return requests
            .getUserFavoriteDashboardsBySiteId(siteId)
            .then((data) => {
                dispatch(getFavoritesSuccess(data));
            })
            .catch((error) => {
                displayErrorSwal(`An error occurred getting user's favorite dashboards at this site, please try again later.`);
                dispatch(getFavoritesFailure(error));
            });
    };
}

//pass in a dashboard object with dashboardId, email, siteId, contributors, name, owner, hits
export function addFavoriteDashboard(dashboard) {
    return (dispatch) => {
        dispatch(addingFavorite());

        return requests
            .addUserFavoriteDashboard(dashboard.dashboardId, dashboard.siteId)
            .then(() => {
                dispatch(postFavoriteDashboardSuccess(dashboard));
            })
            .catch((error) => {
                displayErrorSwal(`An error occurred trying to favorite this dashboard, please try again later.`);
                dispatch(postFavoriteDashboardFailure(error));
            });
    };
}

export function removeFavoriteDashboard(dashboardId) {
    return (dispatch) => {
        dispatch(removingFavorite());

        return requests
            .deleteUserFavoriteDashboard(dashboardId)
            .then(() => {
                dispatch(removeFavoriteDashboardSuccess(dashboardId));
            })
            .catch((error) => {
                displayErrorSwal(`An error occurred trying to remove this favorite dashboard, please try again later.`);
                dispatch(removeFavoriteDashboardFailure(error));
            });
    };
}
